import script from "./SurveyAnswerIssues.vue?vue&type=script&lang=ts&setup=true"
export * from "./SurveyAnswerIssues.vue?vue&type=script&lang=ts&setup=true"

import "./SurveyAnswerIssues.vue?vue&type=style&index=0&id=540181a7&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540181a7"]])

export default __exports__